import { render, staticRenderFns } from "./VPictureUpload.vue?vue&type=template&id=4b08dd2a&"
import script from "./VPictureUpload.vue?vue&type=script&lang=js&"
export * from "./VPictureUpload.vue?vue&type=script&lang=js&"
import style0 from "./VPictureUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports